import { ICheckPasswordReq, ISetPasswordReq, ISetPinReq } from '@/core/domain/entities/request';
import { IResponseAdminWalletBalance } from '@/core/domain/entities/user';
import { checklocal } from '@/utils';
import axios from 'axios';

/**
 * 비밀번호 체크
 * @param {ICheckPasswordReq} reqData
 * @returns {Promise<{ errorCode: string; errorCount?: number } | boolean>}
 */
export async function checkPassword(
  reqData: ICheckPasswordReq,
): Promise<{ errorCode: string; errorCount?: number } | boolean> {
  try {
    const response = await axios.post(`${checklocal()}/member/verifypassword`, reqData);

    return response.data.result;
  } catch (err) {
    console.error(err);
    if (axios.isAxiosError(err)) {
      if (err.response?.data.errorCount) {
        return { errorCode: err.response?.data.errorCode.code, errorCount: err.response?.data.errorCount };
      }
      return { errorCode: err.response?.data.errorCode.code };
    }

    return { errorCode: '0000' };
  }
}

/**
 * 비밀번호 변경
 * @param {ISetPasswordReq} reqData
 * @returns {Promise<{ errorCode: string; errorCount?: number } | boolean>}
 */
export async function setPassword(
  reqData: ISetPasswordReq,
): Promise<{ errorCode: string; errorCount?: number } | boolean> {
  try {
    const response = await axios.post(`${checklocal()}/member/setpassword`, reqData);

    return response.data.result;
  } catch (err) {
    console.error(err);
    if (axios.isAxiosError(err)) {
      if (err.response?.data.errorCount) {
        return { errorCode: err.response?.data.errorCode.code, errorCount: err.response?.data.errorCount };
      }
      return { errorCode: err.response?.data.errorCode.code };
    }

    return { errorCode: '0000' };
  }
}

/**
 * 회원 탈퇴
 * @param {string} id
 * @returns {Promise<{ errorCode: string; errorCount?: number } | boolean>}
 */
export async function withdraw(id: string): Promise<{ errorCode: string; errorCount?: number } | boolean> {
  try {
    const response = await axios.post(`${checklocal()}/member/withdraw`, { id });

    return response.data.result;
  } catch (err) {
    console.error(err);
    if (axios.isAxiosError(err)) {
      if (err.response?.data.errorCount) {
        return { errorCode: err.response?.data.errorCode.code, errorCount: err.response?.data.errorCount };
      }
      return { errorCode: err.response?.data.errorCode.code };
    }

    return { errorCode: '0000' };
  }
}

/**
 * 회원 탈퇴
 * @param {ISetPinReq} reqData
 * @returns {Promise<{ errorCode: string; errorCount?: number } | boolean>}
 */
export async function setPin(reqData: ISetPinReq): Promise<{ errorCode: string; errorCount?: number } | boolean> {
  try {
    const response = await axios.post(`${checklocal()}/member/setpin`, reqData);

    return response.data.result;
  } catch (err) {
    console.error(err);
    if (axios.isAxiosError(err)) {
      if (err.response?.data.errorCount) {
        return { errorCode: err.response?.data.errorCode.code, errorCount: err.response?.data.errorCount };
      }
      return { errorCode: err.response?.data.errorCode.code };
    }

    return { errorCode: '0000' };
  }
}

/**
 *
 *
 * @export
 * @param {string} address
 * @return {*}  {Promise<{ errorCode: string; errorCount?: number } | boolean>}
 */
export async function fetchAdminWalletBalance(
  address: string,
): Promise<{ response: IResponseAdminWalletBalance; status: string; message: string }> {
  try {
    const response = await axios.post(`${checklocal()}/wallet/getbalance/master`, { address });

    if (response.data.status === 'error') {
      return { response: response.data.result, status: 'error', message: response.data.message };
    } else {
      return { response: response.data.result, status: 'success', message: response.data.message };
    }
  } catch (err) {
    console.error(err);
    if (axios.isAxiosError(err)) {
      return { response: err.response?.data, status: '', message: err.response?.data.message };
    }
    return { response: { address: '', balance: 0, chain: '' }, status: 'error', message: 'Internal Server Error' };
  }
}
